import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './app/app';
import './styles.css';
import { i18nReady } from './i18n/i18n';
import { shouldRetryQuery } from './lib/query-retry';

const queryClient = new QueryClient({
  defaultOptions: {
    // 4xx: no retry; 5xx / network: one retry (lib/query-retry.ts).
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: shouldRetryQuery },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Render once the active language's catalog is in (en is bundled; others are a
// small chunk) so the first paint is already in the visitor's language. A
// failed catalog load still renders, in the English fallback.
const render = () =>
  root.render(
    <StrictMode>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </BrowserRouter>
    </StrictMode>
  );
void i18nReady.then(render, render);
